import styled from 'styled-components';

import {
  SYS_PAGE_MARGIN_LG,
  SYS_SPACE_FIXED_500,
  SYS_BREAKPOINT_MD,
  SYS_BREAKPOINT_LG,
  SYS_BREAKPOINT_XL,
  SYS_BREAKPOINT_2_XL,
  SYS_SPACE_FIXED_100,
  SYS_PAGE_MARGIN_XL,
  SYS_PAGE_MARGIN_MD,
  SYS_PAGE_MARGIN_SM,
  SYS_SPACE_RELATIVE_XL,
} from '@oneaudi/unified-web-common';
import { LayoutItem } from '@oneaudi/unified-web-components';
import type { ContainerDivProps, TextWrapperProps } from '../../../@types/interfaces';

export const ContainerDiv = styled.div<ContainerDivProps>`
  ${process.env.IS_LEGACY
    ? // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      (props) => `background-color: ${props?.theme?.sys?.color?.canvas?.default}`
    : ''};
  padding: ${(props) =>
    props.bottomMargin
      ? `${SYS_SPACE_RELATIVE_XL} ${SYS_PAGE_MARGIN_SM}`
      : `${SYS_SPACE_RELATIVE_XL} ${SYS_PAGE_MARGIN_SM} 0`};

  sup a {
    text-decoration: none;
    color: inherit;
  }

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    padding: ${(props) =>
      props.bottomMargin
        ? `${SYS_SPACE_RELATIVE_XL} ${SYS_PAGE_MARGIN_MD}`
        : `${SYS_SPACE_RELATIVE_XL} ${SYS_PAGE_MARGIN_MD} 0`};
  }

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    padding: ${(props) =>
      props.bottomMargin
        ? SYS_SPACE_RELATIVE_XL
        : `${SYS_SPACE_RELATIVE_XL} ${SYS_PAGE_MARGIN_LG} 0`};
  }

  @media (min-width: ${SYS_BREAKPOINT_XL}) {
    padding: ${(props) =>
      props.bottomMargin
        ? `${SYS_SPACE_RELATIVE_XL} ${SYS_PAGE_MARGIN_XL}`
        : `${SYS_SPACE_RELATIVE_XL} ${SYS_PAGE_MARGIN_XL} 0`};
  }
`;

export const TextLayout = styled.div<ContainerDivProps>`
  ${process.env.IS_LEGACY
    ? // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      (props) => `background-color: ${props?.theme?.sys?.color?.canvas?.default}`
    : ''};
  padding: ${(props) => (props.bottomMargin ? `0 0 ${SYS_SPACE_FIXED_500}}` : `0`)};

  ul {
    display: inline-block;
    ${({ justification }) =>
      justification === 'center'
        ? `
        margin: 0;
        padding: 0;
      `
        : ''};

    li {
      margin-left: 0 !important;

      ::before {
        left: unset;
        position: relative !important;
        margin-left: -26px !important;
      }
      ul li::before {
        margin-left: -38px !important;
      }
      sup a:-webkit-any-link {
        color: unset !important;
      }
      ul {
        display: block;
      }
    }
  }

  ol {
    display: inline-block;
    ${({ justification }) =>
      justification === 'center'
        ? `
        margin: 0;
        padding: 0;
      `
        : ''};

    li {
      ::before {
        left: unset;
      }
      sup a:-webkit-any-link {
        color: unset !important;
      }
    }
  }

  @media (min-width: ${SYS_BREAKPOINT_XL}) {
    max-width: ${(props) => (props.reduceTextWidth ? '749px' : 'auto')};
    margin: 0 auto;
  }

  @media (min-width: ${SYS_BREAKPOINT_2_XL}px) {
    max-width: ${(props) => (props.reduceTextWidth ? '849px' : 'auto')};
    margin: 0 auto;
  }

  blockquote {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  q {
    padding: 0 ${SYS_SPACE_FIXED_100};
    :before {
      content: '"';
    }
    :after {
      content: '"';
    }
  }
`;

export const StyledTextLayoutItem = styled(LayoutItem)`
  width: 100%;
`;

export const ButtonContainerDiv = styled.div<TextWrapperProps>`
  margin-block-start: ${SYS_SPACE_FIXED_500};
  margin-bottom: 0;
  text-align: ${({ align }) => align};
`;

export const TextWrapperDiv = styled.div<TextWrapperProps>`
  text-align: ${(props) => props.align};

  pre {
    white-space: pre-wrap;
  }
`;
